import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fmt } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/produit/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group block"
      >
        <div className="glitch-frame aspect-[3/4] border border-white/10 bg-smoke transition-[box-shadow,border-color] duration-500 group-hover:border-ice/40 group-hover:shadow-[0_0_35px_rgba(0,240,255,0.12)]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <img
            src={product.image}
            alt=""
            aria-hidden="true"
            className="glitch-copy w-full h-full object-cover"
          />
          {product.bestseller && (
            <span className="absolute top-3 left-3 bg-ice text-black font-mono text-[10px] font-bold uppercase tracking-widest px-2 py-1">
              Best-seller
            </span>
          )}
          <span className="absolute bottom-3 right-3 bg-black/70 backdrop-blur font-mono text-[10px] uppercase tracking-widest text-zinc-300 px-2 py-1 border border-white/10">
            {product.tag}
          </span>
          <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out bg-black/80 backdrop-blur px-4 py-3 flex items-center justify-between">
            <span className="font-display uppercase tracking-widest text-sm text-white">
              Voir le produit
            </span>
            <ArrowUpRight className="w-4 h-4 text-ice" />
          </div>
        </div>
        <div className="pt-4 flex items-start justify-between gap-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
              {product.gender} / {product.category.replace("-", " ")}
            </p>
            <h3 className="font-display uppercase tracking-wide text-xl leading-tight mt-1 group-hover:text-ice transition-colors duration-300">
              {product.name}
            </h3>
          </div>
          <p className="font-mono text-sm text-ice whitespace-nowrap pt-4">{fmt(product.price)}</p>
        </div>
      </Link>
    </motion.div>
  );
}
